import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    modal: {
      '& .MuiDialog-paper': {
        borderRadius: '12px',
        maxWidth: 900,
        width: 900,
        height: 600,
        '@media (max-width: 900px)': {
          width: '100%',
          height: '100%',
        },
      },
      '& .MuiModal-backdrop': {
        backgroundColor: STYLE.COLOR.MODAL_BACKDROP,
      },
    },
    modalContent: {
      padding: '0px !important',
      overflowY: 'hidden !important' as any,
      backgroundColor: STYLE.COLOR.WHITE,
      display: 'flex',
      flexDirection: 'column',
    },
    modalContentError: {
      backgroundColor: STYLE.COLOR.WHITE,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px !important',
    },
    canvasWrapper: {
      backgroundColor: STYLE.COLOR.TABS_BORDER,
      border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}`,
      borderRadius: '8px',
      margin: '24px 24px 0px 24px',
      display: 'flex',
      flex: 1,
      height: 'auto',
      maxWidth: '100%',
      overflow: 'hidden',
    },
    descriptionText: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
      color: STYLE.COLOR.TEXT2,
      padding: '24px',
    },
    nextButton: {
      minWidth: '250px !important',
    },
    clearButton: {
      minWidth: '136px !important',
      // marginRight: '12px' + '!important',
    },
    signPad: {
      flex: 1,
      width: '100%',
    },
    errorText: {
      color: STYLE.COLOR.ERROR,
      fontSize: 14,
      marginTop: 8,
      marginLeft: 24,
    },
  }),
);
